import { IComponentOptions } from "angular";
import { ContractEditController } from "./controller";

export const vsComponentName = "machineDetailContractEdit";

export const MachineDetailContractEditComponentOptions: IComponentOptions =
  {
    controller: ContractEditController,
    template: require("!html-loader!./index.html").default,
    controllerAs: "stateController",
    bindings: {
      contract:"<"    
    },
  };
